/**
 * HealthContours marketing tokens — same navy/gold language as FusionMSI,
 * sourced from @asi/design-tokens. HealthContours-owned; do not import
 * FusionMSI layout, nav, or star mark.
 */
import { darkTheme, lightTheme } from "@asi/design-tokens";
import { APP_GOLD_METAL, APP_GOLD_METAL_TEXT } from "theme/appDarkTheme";

const { navyDeep, navy, secondaryDark, royalMid } = darkTheme.colors;

/** Dark-mode marketing page backdrop */
export const HEALTHCONTOURS_MARKETING_GRADIENT_DARK = `linear-gradient(155deg, ${navyDeep} 0%, ${navy} 55%, ${secondaryDark} 100%)`;

/** Light-mode marketing page backdrop */
export const HEALTHCONTOURS_MARKETING_GRADIENT_LIGHT = `linear-gradient(155deg, ${lightTheme.colors.primary} 0%, ${royalMid} 100%)`;

export const HEALTHCONTOURS_GOLD_METAL = APP_GOLD_METAL;
export const HEALTHCONTOURS_GOLD_METAL_TEXT = APP_GOLD_METAL_TEXT;

/** sx helper for metal-gradient clipped text (dark-mode wordmark) */
export const healthContoursGoldMetalTextSx = {
  background: HEALTHCONTOURS_GOLD_METAL_TEXT,
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
};

/** sx helper for primary CTAs — metal fill, not flat palette.primary */
export const healthContoursGoldMetalButtonSx = {
  background: HEALTHCONTOURS_GOLD_METAL,
  color: "primary.contrastText",
  fontWeight: 700,
  "&:hover": {
    background: HEALTHCONTOURS_GOLD_METAL,
    opacity: 0.92,
  },
};
